<template>
  <v-app>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <v-container fluid>
              <v-card-title>
                <!--                <v-spacer/>-->
                <!--                {{ $t($route.meta.title) }}-->
                <!--                <v-spacer/>-->
                <!--                <v-btn :loading="loading" @click="getUserNotification()"-->
                <!--                       class="btn-update">-->
                <!--                  <v-icon>mdi-refresh</v-icon>-->
                <!--                  به روزرسانی-->
                <!--                </v-btn>-->
              </v-card-title>
              <v-divider />

              <div class="row">
                <div class="col-md-12 p-5">
                  <v-data-table
                    :headers="headers"
                    :items="data"
                    :footer-props="footerProps"
                    :options.sync="options"
                    :header-props="headerProps"
                    :rows-per-page-items="[10, 20, 30, 40]"
                    :server-items-length="lenght"
                    :loading="loading"
                    :expanded.sync="expanded"
                    show-expand
                    class="elevation-1"
                  >
                    <template v-slot:item.created_at="{ item }">
                      <v-chip color="green" label small class="text-white">
                        {{
                          persian($options.filters.onlyDate(item.created_at))
                        }}
                      </v-chip>
                    </template>
                    <template v-slot:item.time="{ item }">
                      <v-chip color="orange" label small class="text-white">
                        {{
                          persian($options.filters.onlyTime(item.created_at))
                        }}
                      </v-chip>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <th class="p-4" :colspan="headers.length">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th scope="col" class="text-center">عنوان</th>
                                <th scope="col" class="text-center">متن</th>
                                <th scope="col" class="text-center">نماد</th>
                                <th scope="col" class="text-center">عملیات</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-center">
                                  {{ item.data.text }}
                                </td>
                                <td
                                  class="text-center"
                                  v-if="item.data.extra.message"
                                >
                                  {{ item.data.extra.message }}
                                </td>
                                <td class="text-center" v-else>ندارد!</td>
                                <td class="text-center">
                                  <v-icon
                                    v-if="item.data.icon === 'danger'"
                                    color="#ff0000"
                                    >mdi-close-octagon</v-icon
                                  >
                                  <v-icon
                                    v-if="item.data.icon === 'success'"
                                    color="#498E64"
                                    >mdi-check-circle</v-icon
                                  >
                                  <v-icon
                                    v-if="item.data.icon === 'warning'"
                                    color="#FFEF4A"
                                    >mdi-alert</v-icon
                                  >
                                  <v-icon
                                    v-if="item.data.icon === 'info'"
                                    color="#0062D9"
                                    >mdi-information</v-icon
                                  >
                                </td>
                                <td class="text-center">
                                  <v-btn
                                    small
                                    icon
                                    rounded
                                    @click="redirectTo()"
                                    class="btn-show rounded-pill"
                                    v-b-tooltip.hover="'مشاهده '"
                                  >
                                    <v-icon>mdi-eye</v-icon>
                                  </v-btn>
                                  <v-btn
                                    @click="
                                      (dialog = true),
                                        (description =
                                          item.data.extra ?? 'ندارد!')
                                    "
                                    small
                                    icon
                                    class="btn-record rounded-pill"
                                    v-b-tooltip.hover="'خواندن پیام'"
                                  >
                                    <v-icon>mdi-email-mark-as-unread</v-icon>
                                  </v-btn>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </th>
                    </template>
                    <template v-slot:item.read_at="{ item }">
                      <v-chip
                        v-if="item.read_at !== null"
                        color="#01BAEF"
                        label
                        small
                        class="text-white"
                      >
                        {{ persian($options.filters.timeAgo(item.read_at)) }}
                      </v-chip>
                      <v-chip
                        v-else
                        color="#DB3069"
                        label
                        small
                        class="text-white"
                      >
                        خوانده نشده!
                      </v-chip>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </v-container>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="dialog" max-width="800px">
      <v-card color="#282828">
        <v-card-title> </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-flex class="p-2" xs12 sm12 md12 xl12 lg12>
                <div class="text-left h6" dir="ltr">
                  <pre>
                  <code>
                    {{JSON.stringify(description, undefined, 4)}}
                  </code>
                  </pre>
                </div>
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
export default {
  name: "AdminNotifications",
  data() {
    return {
      headerProps: {
        sortByText: "نمایش بر ساس",
      },
      totalDesserts: 0,
      data: [],
      dialog: false,
      description: null,
      isFilter: false,
      footerProps: {
        itemsPerPageText: "تعداد ردیف: ",
        itemsPerPageAllText: "همه",
        itemsPerPageOptions: [10, 25, 50, 100, 200, 400],
        pageText: "از",
        showCurrentPage: true,
        showFirstLastPage: true,
      },
      expanded: [],
      lenght: null,
      singleExpand: false,
      loading: false,
      options: {},
      headers: [
        {
          text: "شناسه",
          value: "id",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "عنوان",
          value: "data.title",
          align: "center",
          class: "font-weight-bold h6",
          sortable: false,
        },
        {
          text: "نام سرویس",
          value: "data.service",
          align: "center",
          class: "font-weight-bold h6",
          sortable: false,
        },
        {
          text: "تاریخ ایجاد",
          value: "created_at",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "ساعت ایجاد",
          value: "time",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "تاریخ خواندن",
          value: "read_at",
          align: "center",
          class: "font-weight-bold h6",
        },
        { text: "", value: "data-table-expand" },
      ],
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      count: 0,
      urlNotif: "notificationAdmin",
    };
  },
  methods: {
    redirectTo() {
      if (this.count === 0) this.$toast.info("درحال بروزرسانی ...");
      if (this.count === 1) this.$toast.warning("درحال بروزرسانی ...");
      this.count++;
    },
    getUserNotification(url = this.urlNotif, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then(({ data }) => {
          this.loading = false;
          this.isFilter = true;
          this.data = data.data;
          this.lenght = data.total;
        })
        .catch(({ response }) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getUserNotification(this.urlNotif);
  },
  watch: {
    options(val) {
      if (this.isFilter) {
        this.tableProps.page = val.page;
        this.tableProps.length = val.itemsPerPage;
        this.tableProps.column = val.sortBy[0] ?? "id";
        if (!val.sortDesc[0]) this.tableProps.dir = "asc";
        else this.tableProps.dir = "desc";
        this.getUserNotification(this.urlNotif, this.tableProps);
      }
    },
  },
};
</script>

<style scoped>
pre {
  outline: 1px solid #ccc;
  padding: 5px;
  margin: 5px;
  background-color: #282828;
  color: white;
}
.string {
  color: green !important;
}
.number {
  color: darkorange !important;
}
.boolean {
  color: blue !important;
}
.null {
  color: magenta !important;
}
.key {
  color: red !important;
}
</style>
